// removed by extract-text-webpack-plugin
module.exports = {"headerPreloader":"price__headerPreloader-2cZCo","headerPriceValue":"price__headerPriceValue-2-AEU","multiplySymbol":"price__multiplySymbol-3xbPm","rouble":"price__rouble-3Iz78","asterisk":"price__asterisk-UA4oq"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/price/price.css
// module id = 765
// module chunks = 0